import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Row } from "react-bootstrap";

import {
  OpenSupportTicketsFilters,
  OpenSupportTicketsTable
} from "./components";

import { OPEN_SUPPORT_TICKETS_COLUMNS } from "./components/OpenSupportTicketsTable/OpenSupportTickets.columns";

import Loading from "../../common/Loading";
import { customToast as toast } from "../../../utils";
import { downloadCSV } from "../utils";

const OpenSupportTickets = ({ isMobile, report, loading }) => {
  const [exporting, setExporting] = useState(false);

  const handleExportClick = async () => {
    if (report.length) {
      setExporting(true);
      try {
        const name = "Open Support Tickets Report";
        const columns = OPEN_SUPPORT_TICKETS_COLUMNS.map((column) => {
          if (
            column.id === "call.internal_notes" ||
            column.id === "supportTicket.request_nature_details"
          ) {
            return {
              Header: column.Header,
              accessor: column.accessor
            };
          }
          return column;
        });
        await downloadCSV(
          name,
          report.map((item) => ({
            ...item,
            call: {
              ...item.call,
              internal_notes: item.call.internal_notes
                ? item.call.internal_notes.replace(/(\r\n|\n|\r)/gm, "")
                : ""
            },
            supportTicket: {
              ...item.supportTicket,
              request_nature_details: item.supportTicket.request_nature_details
                ? item.supportTicket.request_nature_details.replace(
                    /(\r\n|\n|\r)/gm,
                    ""
                  )
                : ""
            }
          })),
          columns
        );
      } catch (err) {
        toast.error(err.message);
      } finally {
        setExporting(false);
      }
    }
  };

  return (
    <div>
      <OpenSupportTicketsFilters
        onExportClick={handleExportClick}
        isMobile={isMobile}
        exporting={exporting}
      />
      {loading && (
        <Row style={{ display: "flex", justifyContent: "center" }}>
          <Loading />
        </Row>
      )}
      {!loading && <OpenSupportTicketsTable data={report} />}
    </div>
  );
};

OpenSupportTickets.propTypes = {
  isMobile: PropTypes.bool,
  report: PropTypes.array,
  loading: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    report: state.reducers.OSTReport,
    loading: state.reducers.loading,
    codes: state.reducers.codes
  };
}

export default connect(mapStatesToProps, null)(OpenSupportTickets);
